<template>
  <div class="foot-container">
    <div class="foot">{{msg}}</div>
  </div>
</template>
<script>
export default {
  name: 'Footer',
  data () {
    return {
      msg: 'Copyright©2023 深圳市小学英语教研中心组'
    }
  }
}
</script>
<style scoped>
.foot-container{
  width: 100%;
  height: 96px;
  background: #fff;
}
.foot{
  line-height: 96px;
  text-align: center;
  font-size: 15px;
}
</style>
